// よく使うstyledComponentをここにまとめる
// 追加する際は具体的なコメントを追加すること
// 汎用的ではないものを作成したいときは、スプレッド展開を用いて上書きして使ってください
import { CustomStyle } from '@/appLogic/interfaces/style';
import styled from 'vue-styled-components';

// Constants
export const sideBarWidth = '230px'; // サイドバーの幅
export const sideBarShortWidth = '100px'; // 閉じた状態のサイドバーの幅
export const HeaderHeight = '66px'; // ヘッダーの高さ
export const contentMargin = '8px'; // 基本マージン
export const defaultTableColumnWidthValue = 88; // テーブルのデフォルト列幅
export const minTableColumnWidthValue = 88; // テーブルの最小列幅
export const maxTableColumnWidthValue = 420; // テーブルの最大列幅

// color (TODO: ちゃんと色に関するルールを決めて統一する)
export const primaryColor = '#4DBCE9'; // 基本色
export const backgroundColor = '#F0EEEE'; // 基本色
export const selectedBackgroundColor = '#C1C1C1'; // 基本色

// text
/**
 * 100pxのような文字列から、文字列を取り除く
 * @param pxString 100pxのような文字列
 */
export const removePxString = (pxString: string): number => {
  // 数値が含まれた文字列から、数値のみを取り出し、returnする
  return Number(pxString.replace(/[^0-9]/g, ''));
};

// ---------------------------------- FlexLayout --------------------------------------------------
// レイアウトの親要素
export const flexWrapper = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  background-color: #f0f0f0;
  width: 100%;
  height: 100%;
`;

// 横一列に並べる
export const flexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

// 縦一列に並べる
export const flexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

// ---------------------------------- FlexLayout --------------------------------------------------

// ---------------------------------- GridLayout --------------------------------------------------
export const gridWrapper = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
`;

// 横一列に並べる
export const gridRow = styled.div`
  display: grid;
  flex-direction: row;
`;

// 縦一列に並べる
export const gridColumn = styled.div`
  display: grid;
  flex-direction: column;
`;

// ---------------------------------- GridLayout --------------------------------------------------

// ---------------------------------- border --------------------------------------------------
export const baseBorder = styled.div`
  border: 2px solid darkgray;
  border-radius: 10px;
`;
// ---------------------------------- border --------------------------------------------------

// 2emの間隔を空ける
export const padding2em = styled.section`
  padding: 2em;
`;

export const paddingBottom1em = styled.section`
  padding-bottom: 1em;
`;

// 表示テキストを空間の中心に寄せるために使用する
export const textCenterWrapper = styled.div`
  text-align: center;
`;
